<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" :width="computedWidth" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          {{ computedTitle }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout wrap>
              <!-- Identificação -->
              <v-flex xs12>
                <span class="subheading font-weight-medium">Identificação</span>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 md4>
                <v-radio-group v-model="computedTipoPessoa" row hide-details>
                  <v-radio label="Física" value="F" color="primary"></v-radio>
                  <v-radio label="Jurídica" value="J" color="primary"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 md5>
                <v-autocomplete 
                  v-model="colaborador.Equipe"
                  :items="equipesAtivo"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Equipe"
                  no-data-text="Registro não encontrado."
                  prepend-icon="folder"
                  hide-details
                  auto-select-first
                  clearable
                  @change="changeEquipe"
                  @focus="fetchEquipes"
                  @click="fetchEquipes"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md3>
                <v-menu v-model="colaboradorDatepicker" :close-on-content-click="false" full-width>
                  <v-text-field slot="activator" hide-details
                    :value="moment(dataNascimento).format('DD/MM/YYYY')" label="Nascimento" prepend-icon="event">
                  </v-text-field>
                  <v-date-picker locale="pt" v-model="dataNascimento" @change="changeColaboradorDatepicker"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="colaborador.Descricao"
                  label="Nome"
                  prepend-icon="person"
                  hide-details
                  :rules="[rules.required]"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  v-model="colaborador.CpfCnpj"
                  label="CPF/CNPJ"
                  :mask="cpfCnpjMask"
                  return-masked-value
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md5>
                <v-text-field
                  v-model="colaborador.RgIe"
                  label="RG/IE"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-autocomplete 
                  v-model="colaborador.TipoColaborador"
                  :items="tiposColaboradorAtivo"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Tipo Colaborador"
                  no-data-text="Registro não encontrado."
                  prepend-icon="folder"
                  hide-details
                  auto-select-first
                  clearable
                  @change="changeTipoColaborador"
                  @focus="fetchTiposColaborador"
                  @click="fetchTiposColaborador"
                ></v-autocomplete>
              </v-flex>
              <!-- Endereço -->
              <v-flex xs12 pt-3>
                <span class="subheading font-weight-medium">Endereço</span>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  v-model="colaborador.Cep"
                  label="CEP"
                  prepend-icon="place"
                  :hide-details="!buscaCepErro"
                  counter="8"
                  mask="#####-###"
                  :loading="buscaCepLoading"
                  :hint="buscaCepRetorno"
                  :persistent-hint="buscaCepErro"
                  :rules="[rules.cep]"
                  @keyup.enter="buscaCep"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md7>
                <v-text-field
                  v-model="colaborador.Endereco"
                  label="Endereço"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md2>
                <v-text-field
                  v-model="colaborador.Numero"
                  label="Numero"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="colaborador.Complemento"
                  label="Complemento"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="colaborador.PontoReferencia"
                  label="Ponto Referência"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete 
                  v-model="colaborador.Bairro"
                  :items="bairrosAtivo"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Bairro"
                  hide-details
                  auto-select-first
                  cache-items
                  no-data-text="Registro não encontrado."
                  prepend-icon="folder"
                  clearable
                  @change="changeBairro"
                  @focus="fetchBairros"
                  @click="fetchBairros"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete 
                  v-model="colaborador.Cidade"
                  :items="cidades"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Cidade"
                  hide-details
                  auto-select-first
                  cache-items
                  no-data-text="Registro não encontrado."
                  prepend-icon="folder"
                  clearable
                  @change="changeCidade"
                  @focus="fetchCidades"
                  @click="fetchCidades"
                ></v-autocomplete>
              </v-flex>
              <!-- Contatos -->
              <v-flex xs12 pt-3>
                <span class="subheading font-weight-medium">Contatos</span>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="colaborador.Telefone"
                  label="Telefone"
                  hide-details
                  :mask="telefoneMask"
                  prepend-icon="phone"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="colaborador.Email"
                  label="E-mail"
                  prepend-icon="mail"
                  :rules="[rules.email]"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Colaborador from '@/domain/colaborador/Colaborador';

export default {
  name: 'ModalCadastroColaborador',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    colaborador: {
      type: Object,
      default: () => new Colaborador()
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      colaboradorDatepicker: false,
      buscaCepErro: false,
      buscaCepLoading: false,
      buscaCepRetorno: '',
      rules: {
        required: value => !!value || 'Campo obrigatório.',
        cep: value => value && value.length === 8 || 'CEP inválido.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Formato do e-mail inválido.';
        }
      }
    }
  },
  computed: {
    ...mapGetters(['tiposColaboradorAtivo', 'bairrosAtivo', 'cidades', 'equipesAtivo']),
    dataNascimento: {
      get() {
        if (this.colaborador && this.colaborador.DataNascimento) {
          return new Date(this.colaborador.DataNascimento).toISOString().substr(0, 10);
        } else {
          return new Date(1970, 0, 1, 0, 0, 0).toISOString().substr(0, 10);
        }
      },
      set(value) {
        this.changeColaboradorDatepicker(value);
      }
    },
    computedTitle() {
      return this.colaborador.IdColaborador ? 'Editar Colaborador' : 'Novo Colaborador';
    },
    computedWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%';
        case 'sm': return '100%';
        case 'md': return '85%';
        case 'lg': return '60%';
        case 'xl': return '50%';
      }
    },
    computedTipoPessoa: {
      get() {
        return this.colaborador.TipoPessoa.trim();
      },
      set(value) {
        this.colaborador.TipoPessoa = value.trim();
      }
    },
    cpfCnpjMask() {
      if (this.colaborador.TipoPessoa.startsWith('F')) return '###.###.###-##';
      return '##.###.###/####-##';
    },
    telefoneMask() {
      if (this.colaborador.Telefone && this.colaborador.Telefone[2] == 9) return '(##) # ####-####';
      if (this.colaborador.Telefone && this.colaborador.Telefone[2] != 9) return '(##) ####-####';
      return '(##) # ####-####';
    },
    computedStatus() {
      return this.colaborador.Status.trim();
    },
  },
  methods: {
    ...mapActions([
      'addColaborador',
      'updateColaborador',
      'fetchTiposColaborador',
      'fetchBairros',
      'fetchCidades',
      'fetchEquipes',
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    // buscaCnpj() {
    //   let cnpj = this.colaborador.CpfCnpj.replace('.', '').replace('/', '').replace('-', '');
    //   let url = `https://www.receitaws.com.br/v1/cnpj/${cnpj}`;
    //   fetch(url, {
    //     headers: {
    //       'Authorization': `Bearer e9ff4559d868663a9f292cb1c833efaddffc309593154c43804850410525b8ed`
    //     }
    //   })
    //     .then(res => res.json())
    //     .then(json => console.log(json))
    //     .catch(err => console.log(err.message));
    // },
    buscaCep() {
      this.buscaCepLoading = true;
      let cep = this.colaborador.Cep.replace('-', '');
      let url = `http://viacep.com.br/ws/${cep}/json`;
      fetch(url)
        .then(res => res.json())
        .then(json => {
          if (this.colaborador.Endereco && confirm('Deseja substituir o endereço atual?')) {
            this.buscaCepErro = false;
            this.buscaCepRetorno = '';
            this.buscaCepLoading = false;
            return this.preencheCepAuto(json);
          } else {
            this.buscaCepErro = false;
            this.buscaCepRetorno = '';
            this.buscaCepLoading = false;
            return this.preencheCepAuto(json)
          }
        })
        .catch(err => {
          this.buscaCepRetorno = 'CEP não encontrado.';
          this.buscaCepErro = true;
          this.buscaCepLoading = false;
          console.log(err);
        });
    },
    preencheCepAuto(json) {
      if (typeof json == 'object') {
        const { logradouro, complemento, bairro, localidade } = json;
        this.colaborador.Endereco = logradouro;
        this.colaborador.Complemento = complemento;
        // Preenche bairro
        const bairroEncontrado = this.bairrosAtivo.find(b => this.converteStringParaComparacao(b.Descricao) == this.converteStringParaComparacao(bairro));
        if (bairroEncontrado) {
          this.colaborador.IdBairro = bairroEncontrado.IdBairro;
          this.colaborador.Bairro = bairroEncontrado.Descricao;
        }
        // Preenche cidade
        const cidadeEncontrada = this.cidades.find(c => this.converteStringParaComparacao(c.Descricao) == this.converteStringParaComparacao(localidade));
        if (cidadeEncontrada) {
          this.colaborador.IdCidade = cidadeEncontrada.IdCidade;
          this.colaborador.Cidade = cidadeEncontrada.Descricao;
        }
      } else {
        console.log('json inválido');
      }
    },
    converteStringParaComparacao(text) {
      const a = 'àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
      const b = 'aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
      const p = new RegExp(a.split('').join('|'), 'g')
      return text.toString().toLowerCase().trim()
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special chars
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[\s\W-]+/g, '-') // Replace spaces, non-word characters and dashes with a single dash (-)
    },
    async buscaBairros() {
      if (!this.bairrosAtivo.length) {
        await this.fetchBairros();
      }
    },
    async buscaCidades() {
      if (!this.cidades.length) {
        await this.fetchCidades();
      }
    },
    async buscaTiposColaborador() {
      if (!this.tiposColaboradorAtivo.length) {
        await this.fetchTiposColaborador();
      }
    },
    async buscaEquipes() {
      if (!this.equipesAtivo.length) {
        await this.fetchEquipes();
      }
    },
    changeColaboradorDatepicker(data) {
      const [ano, mes, dia] = data.split('-');
      this.colaborador.DataNascimento = new Date(ano, mes - 1, dia);
      this.colaboradorDatepicker = false;
    },
    changeEquipe(obj) {
      if (obj && typeof obj === 'object') {
        this.colaborador.IdEquipe = obj.IdEquipe;
        this.colaborador.Equipe = obj.Descricao;
      } else {
        this.colaborador.IdEquipe = undefined;
        this.colaborador.Equipe = '';
      }
    },
    changeTipoColaborador(obj) {
      if (obj && typeof obj === 'object') {
        this.colaborador.IdTipoColaborador = obj.IdTipoColaborador;
        this.colaborador.TipoColaborador = obj.Descricao;
      } else {
        this.colaborador.IdTipoColaborador = undefined;
        this.colaborador.TipoColaborador = '';
      }
    },
    changeBairro(obj) {
      if (obj && typeof obj === 'object') {
        this.colaborador.IdBairro = obj.IdBairro;
        this.colaborador.Bairro = obj.Descricao;
      } else {
        this.colaborador.IdBairro = undefined;
        this.colaborador.Bairro = '';
      }
    },
    changeCidade(obj) {
      if (obj && typeof obj === 'object') {
        this.colaborador.IdCidade = obj.IdCidade;
        this.colaborador.Cidade = obj.Descricao;
      } else {
        this.colaborador.IdCidade = undefined;
        this.colaborador.Cidade = '';
      }
    },
    async adiciona() {
      if (!this.colaborador.IdColaborador && this.colaborador.Descricao) {
        this.loading = true;
        const newColaborador = Object.assign({}, this.colaborador);
        try {
          await this.addColaborador(newColaborador);
          this.showNotification({ text: `Colaborador: ${newColaborador.Descricao} adicionado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('colaboradorAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o colaborador: ${error}.`, status: 'error' });
        }
      } else if (this.colaborador.IdColaborador && this.colaborador.Descricao) {
        this.loading = true;
        const updColaborador = Object.assign({}, this.colaborador);
        try {
          await this.updateColaborador(updColaborador);
          this.showNotification({ text: `Colaborador: ${updColaborador.Descricao} atualizado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('colaboradorAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao atualizar o colaborador: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe o Nome do colaborador.`, status: 'error' });
      }
    }
  },
  async created() {
    await this.buscaBairros();
    await this.buscaCidades();
    await this.buscaTiposColaborador();
    await this.buscaEquipes();
  }
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1rem !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
